"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const getSearchQuery = (searchParams = {}) => {
    const formatSearchValue = (value) => (0, lodash_1.isArray)(value) ? value.join(',') : value === null || value === void 0 ? void 0 : value.toString();
    const searchQueryEntries = Object.entries(searchParams)
        .flatMap(([searchType, searchValue]) => {
        if ((0, lodash_1.isArray)(searchValue)) {
            return [[`${searchType}[]`, formatSearchValue(searchValue)]];
        }
        else if ((0, lodash_1.isObject)(searchValue)) {
            return [
                ...Object.entries(searchValue).map(([attributeName, attributeValue]) => [
                    `${searchType}[${attributeName}]`,
                    formatSearchValue(attributeValue),
                ]),
            ];
        }
        else {
            return [[searchType, formatSearchValue(searchValue)]];
        }
    })
        .filter(([_, value]) => Boolean(value));
    return Object.fromEntries(searchQueryEntries);
};
exports.default = getSearchQuery;
